var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMarketing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 2a3 3 0 0 0-3 3v1H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-3V5a3 3 0 0 0-3-3zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zM8 8H4a1 1 0 0 0-1 1v2h18V9a1 1 0 0 0-1-1zm4 5h1.5c0 .356-.452 1-1.5 1s-1.5-.644-1.5-1zm-3.5 0H3v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6h-5.5c0 1.854-1.787 3-3.5 3s-3.5-1.146-3.5-3",
  clipRule: "evenodd"
})));
export default SvgIcMarketing;